import { UserFacingError } from './errors'

export class FeedbackNotFoundError extends UserFacingError {
  constructor() {
    super("This feedback isn't available.")
    this.name = 'FeedbackNotFoundError'
  }
}
